import posthog, { type PostHog } from 'posthog-js'

// PostHog is production-only for now. In other environments the singleton is left
// uninitialized, so capture calls (e.g. global-error.tsx) log a warning and no-op
// instead of sending events.
const enabled = import.meta.env.VITE_ENVIRONMENT === 'production'

export const initPostHog = (): PostHog => {
  if (!enabled) return posthog

  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    defaults: '2026-05-30',
  })

  return posthog
}
